
export default Object.freeze({
	FETCH_SPECIMEN: 'FETCH_SPECIMEN',
	FETCH_SPECIMENS: 'FETCH_SPECIMENS',
	CLEAR_SPECIMEN: 'CLEAR_SPECIMEN'
})